export const Tier4PassiveCollectibles = [
    ['Cricket\'s Head', '4'],
    ['Magic Mushroom', '12'],
    ['Dr. Fetus', '52'],
    ['The Wafer', '108'],
    ['Mom\'s Knife', '114'],
    ['Brimstone', '118'],
    ['Ipecac', '149'],
    ['Epic Fetus', '168'],
    ['Polyphemus', '169'],
    ['Sacred Heart', '182'],
    ['Pyromaniac', '223'],
    ['Stop Watch', '232'],
    ['Infestation 2', '234'],
    ['20/20', '245'],
    ['Proptosis', '261'],
    ['Holy Mantle', '313'],
    ['Godhead', '331'],
    ['Incubus', '360'],
    ['Tech X', '395'],
    ['Maw of the Void', '399'],
    ['Crown of Light', '415'],
    ['Broken Shovel', '551'],
    ['Psy Fly', '581'],
    ['Revelation', '643'],
    ['Binge Eater', '664'],
    ['C Section', '678'],
    ['Glitched Crown', '689'],
    ['Sacred Orb', '691'],
    ['Twisted Pair', '698'],
];